<div class="representative-table-container">
  <astral-checkbox [checked]="dataContext" [disabled]="true" [showCaption]="false" [variant]="'compact'"></astral-checkbox>
</div>
